// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"5ffb1205","238":"4656cfce","682":"a1fe997b","852":"0c513a5d","965":"064502fd"}[chunkId] + ".chunk.js";
};